import React from "react";
import "./Footer.css";

function Footer(): React.ReactElement {
  const currentYear = new Date().getFullYear();
  return (
    <div className="copyrightText">
    <p> Powered by Iykons</p>
    </div>
  );
}

export default Footer;
